import styled from "styled-components"
import { Link } from "../../../ui"
import { BreakPoints, media } from "../../../helpers/rwd"
import {
  ButtonsWrapperStyles,
  LogoWrapperStyles,
  MenuItemsStyles,
  MenuLinkStyles,
  MenuOverlayStyles,
  MenuWrapperStyles,
  SubmenuLinkStyles,
} from "./mobile-menu-styles"

export const MenuOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000 !important;
  display: none;
  ${media.max(BreakPoints.desktop)} {
    display: block;
  }
  ${MenuOverlayStyles}
`

export const MenuWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 300px;
  padding: 40px 0;
  ${MenuWrapperStyles}
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
  ${LogoWrapperStyles}
`

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  ${MenuItemsStyles}
`

export const MenuLink = styled(Link)`
  width: 100%;
  padding: 10px 20px;
  ${MenuLinkStyles}
`

export const SubmenuLink = styled(Link)`
  width: 100%;
  padding: 10px 20px 10px 40px;
  ${SubmenuLinkStyles}
`

export const ButtonsWrapper = styled.div`
  margin: 40px 30px 0 30px;
  & > a {
    margin-bottom: 20px;
  }
  ${ButtonsWrapperStyles}
`
